import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import PageHeader from '@shared/PageHeader';

import WorkOrderForm from './components/WorkOrderForm';

const WorkOrderNew = () => {
  return (
    <MerchantSelect>
      {(props) => (
        <div>
          <PageHeader items={['production', 'production.work_orders', 'production.work_orders.new']} />
          <WorkOrderForm {...props} />
        </div>
      )}
    </MerchantSelect>
  );
};

export default WorkOrderNew;